import { supabase }             from '@/shared/lib/supabase';
import type { IPolaroidRepository } from '../domain/ports/IPolaroidRepository';
import type { InteracaoPolaroid, StatusPolaroid } from '@/shared/types';

export const polaroidRepository: IPolaroidRepository = {

  async listarPendentes(empresaId: string): Promise<InteracaoPolaroid[]> {
    const { data, error } = await supabase
      .from('interacao_polaroids')
      .select('*')
      .eq('empresa_id', empresaId)
      .eq('status', 'pendente')
      .order('created_at', { ascending: false });

    if (error) throw error;
    return (data ?? []) as InteracaoPolaroid[];
  },

  async inserir(payload: Omit<InteracaoPolaroid, 'id' | 'created_at' | 'status' | 'storage_path'>): Promise<void> {
    const { error } = await supabase
      .from('interacao_polaroids' as never)
      .insert(payload as never);

    if (error) throw error;
  },

  async atualizarStatus(empresaId: string, id: string, status: StatusPolaroid): Promise<void> {
    const { error } = await supabase
      .from('interacao_polaroids' as never)
      .update({ status } as never)
      .eq('empresa_id', empresaId)
      .eq('id', id);

    if (error) throw error;
  },

  async buscarPhotoData(telaId: string, id: string) {
    const { data, error } = await supabase.rpc('polaroid_foto_aprovada' as never, {
      p_tela_id: telaId,
      p_id: id,
    } as never);
    if (error) return null;
    const row = (Array.isArray(data) ? data[0] : data) as
      { photo_data: string | null; identificacao: string | null } | undefined;
    if (!row?.photo_data) return null;
    return row;
  },
};
